import { Link } from 'react-router-dom'
import { useState } from 'react'
import { ServicePlaceHolder } from '../utils/ImagePlaceholder'

const ServiceItem = (props) => {
    const [Imageloading, setImageLoading] = useState(true)

    const imageLoaded = () => {
        setImageLoading(false)
        
    }
    return (
        <Link className="service-item" to={`/services/${props.service.slug}`}>
                <div className="service-icon">
                    <img src={`${props.baseUrl}${props.service.icon}`} alt={props.service.slug} className="service-img" onLoad={imageLoaded} style={{display: Imageloading ? "none" : "block"}}/>
                    {Imageloading ? <ServicePlaceHolder width="80px" height="80px"/> : ""}
                </div>
                <div>{props.service.name}</div>
        </Link>
    )
}

export default ServiceItem


// {/* <Link key={service.id} className="service-item" to={`/services/${service.slug}`}>
//                 <div className="service-icon"><img src={`${BASE_URL}${service.icon}`} alt={service.slug} className="service-img" onLoad={imageLoaded}/></div>
//                 <div>{service.name}</div>
//             </Link> */}